import { render, staticRenderFns } from "./PageTitleDropdown.ts.vue?vue&type=template&id=34c9e884&"
import script from "./PageTitleDropdown.ts.vue?vue&type=script&lang=ts&"
export * from "./PageTitleDropdown.ts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports